import { useState } from 'react';
import { Button, CenterScreenModal } from '../atoms'
import { 
  useAddSupplierFormModalContext,
  useErrorHandlerContext,
  useIncidentDetailContext,
  useOpeningElementsControllerContext,
  useUserLanguage,
} from '@/customHooks'
import { Col, Row } from 'react-grid-system';
import { useSetSupplierToIncidentMutation } from '@/graphql/generated';
import { SuppliersSimpleSelectionList } from '../organism';
import { SimpleSupplierProps } from '@/custom-types';

const textsData = {
  en: {
    title: 'Assign a Supplier',
    confirmation: {
      title: 'Supplier Assigned',
      description: (supplierName: string) => `Supplier ${supplierName} has been assigned successfully.`,
    },
    button: {
      confirm: 'Confirm',
      cancel: 'Cancel'
    }
  },
  es: {
    title: 'Asignar un Proveedor',
    confirmation: {
      title: 'Proveedor Asignado',
      description: (supplierName: string) => `El proveedor ${supplierName} ha sido asignado con éxito.`,
    },
    button: {
      confirm: 'Confirmar',
      cancel: 'Cancelar'
    }
  }
}

export const AddSupplierFormModal = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en;

  const [selectedSupplier, setSelectedSupplier] = useState<SimpleSupplierProps | null>(null);
  
  const [setSupplier, { loading: updateLoading }] = useSetSupplierToIncidentMutation()

  const { confirmDialogModalOpen } = useOpeningElementsControllerContext()

  const { isOpen, closeModal } = useAddSupplierFormModalContext()

  const { incident, setIncident } = useIncidentDetailContext()
  
  const { open: errorHandle } = useErrorHandlerContext()

  const onSelectSupplier = (supplier: SimpleSupplierProps) => {
    setSelectedSupplier(supplier);
  }

  const onConfirmHandle = () => {
    if (!selectedSupplier || !incident) return
    
    setSupplier({ variables: {
      incidentId: incident.id,
      input: { supplierId: selectedSupplier.user.id }
    }})
    .then(() => {
      closeModal()
      confirmDialogModalOpen({
        title: texts.confirmation.title,
        description: texts.confirmation.description(`${selectedSupplier.firstName} ${selectedSupplier.lastName}`),
      })
      setIncident(undefined) // Force refetch
    })
    .catch((error) => {
      closeModal()
      errorHandle(error)
    })
  }
  
  return (
    <CenterScreenModal
      isOpen={isOpen}
      onClose={closeModal}
    >
      <Row>
        <Col>
          <h2>{texts.title}</h2>
        </Col>
      </Row>
      <SuppliersSimpleSelectionList selected={onSelectSupplier} />
      <br />
      <Row justify="center" gutterWidth={32}>
        <Col xs="content">
          <Button secondary onClick={closeModal} disabled={updateLoading}>
            {texts.button.cancel}
          </Button>
        </Col>
        <Col xs="content">
          <Button
            onClick={() => onConfirmHandle()}
            isLoading={updateLoading}
            disabled={!selectedSupplier}
          >
            {texts.button.confirm}
          </Button>
        </Col>
      </Row>
    </CenterScreenModal>
  )
}
